const INITIAL_STATE = {
  formulas: [],
  pagination: {
    page: 1,
    itemsPerPage: 15,
    totalItems: 0
  }
}

export default function representanteFormulaListReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'REPRESENTANTE_FORMULA_LIST_SET_FORMULAS':
      return {
        ...state,
        formulas: action.payload
      }
    case 'REPRESENTANTE_FORMULA_LIST_PAGINATION_SET_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      }
    case 'REPRESENTANTE_FORMULA_LIST_PAGINATION_SET_ITEMS_PER_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          itemsPerPage: action.payload
        }
      }
    case 'REPRESENTANTE_FORMULA_LIST_PAGINATION_SET_TOTAL_ITEMS':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalItems: action.payload
        }
      }
    case 'REPRESENTANTE_FORMULA_LIST_CLEAR_ALL':
      return {
        ...state,
        ...INITIAL_STATE
      }
    default:
      return state
  }
}
